import { render, staticRenderFns } from "./support-chat-message.vue?vue&type=template&id=05b8f753&scoped=true"
import script from "./support-chat-message.vue?vue&type=script&lang=js"
export * from "./support-chat-message.vue?vue&type=script&lang=js"
import style0 from "./support-chat-message.vue?vue&type=style&index=0&id=05b8f753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8f753",
  null
  
)

export default component.exports